var styles = {"square":"styles_square__7F2In"};

export default styles;
//# sourceMappingURL=styles.css.js.map
